import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';

import {AgendaService} from 'src/app/services/agenda.service';
import {EventService} from 'src/app/services/event.service';
import {MemberService} from 'src/app/services/member.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {LetterV2} from 'src/app/models/letter-v2';
import {LetterSpeakersService} from 'src/app/services/letter-speakers.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-letters-speakers-dialog',
  templateUrl: './letters-speakers-dialog.component.html',
  styleUrls: [ './letters-speakers-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class LettersSpeakersDialogComponent implements OnInit {

  public isCongress: boolean;

  public Editor = ClassicEditor;

  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  public event: any;
  public letter: any;

  public types: any = [];

  public templates: any[] = [];
  public selectedTemplate: any = {};

  constructor (
    private fb: FormBuilder,
    public _letterSpeakersService: LetterSpeakersService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    public _agendaService: AgendaService,
    public _eventService: EventService,
    public _memberService: MemberService,
    private ff: AngularFireFunctions,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.isCongress = this.data.isCongress
    //console.log("this.data.event: " + JSON.stringify(this.data.event))

    this.event = this.data.event;
    this.letter = this.data.letter;

    this.types.push(
      {'id': '0', 'name': 'Confirmar'}, //confirma e atualiza os dados
      //   {'id': '1', 'name': 'Atualizar'}, //atualiza
    )

  }

  ngOnInit () {
    this._adapter.setLocale('pt');

    this.loadTemplates(this.isCongress);

    if (this.data.letter.id != "0") {
      this.isEdit = true;
      this.local_title = "Carta"; //this.data.letter.name
    } else {
      this.isEdit = false
      this.local_title = "Nova Carta"
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.letter, this.entityForm)

  }

  insert () {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: LetterV2 = this.createEntity(this.entityForm.value);
      console.log("entity insert: " + JSON.stringify(entity))

      this._letterSpeakersService.insert(entity)
        .then((result) => {
          this.data.letter.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch(() => {
          console.log("insert letter error")
          this.snackBar.openSnackBar("Erro", '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update () {
    if (this.entityForm.valid) {

      this.spinner = true;
      let entity: LetterV2 = this.createEntity(this.entityForm.value);
      //console.log("entity update: " + JSON.stringify(entity))

      this._letterSpeakersService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch(() => {
          console.log("update letter error")
          this.snackBar.openSnackBar("Erro", '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
        
    }
  }

  createEntity (data: any): LetterV2 {

    let entity = new LetterV2();

    entity.id = data.id;
    entity.name = data.name;
    entity.subject = data.subject;
    entity.type = data.type;
    entity.text = data.text;
    entity.isCongress = this.isCongress
    entity.context_id = this.event.context_id
    entity.event_id = this.event.id
    entity.event_name = this.event.name
    entity.isTemplate = data.isTemplate ? true : false
    //   entity.imageTop = data.imageTop
    //   entity.imageBottom = data.imageBottom
    //   entity.imageBottom = data.imageBody

    return entity;
  }

  setFormValues (data, form) {

    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.subject.setValue(data.subject);
    form.controls.type.setValue(data.type);
    form.controls.text.setValue(data.text);
    form.controls.isCongress.setValue(data.isCongress);
    form.controls.isTemplate.setValue(data.isTemplate);
    form.controls.imageTop.setValue(data.imageTop);
    form.controls.imageBottom.setValue(data.imageBottom);
    form.controls.imageBody.setValue(data.imageBody);

    this._letterSpeakersService.storedImageTop = data.imageTop;
    this._letterSpeakersService.storedImageBottom = data.imageBottom;
    this._letterSpeakersService.storedImageBody = data.imageBody;
  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      subject: new FormControl('', [ Validators.required ]),
      type: new FormControl('', [ Validators.required ]),
      text: new FormControl('', [ Validators.required ]),
      isCongress: new FormControl(false),
      isTemplate: new FormControl(false),
      imageTop: new FormControl(''),
      imageBottom: new FormControl(''),
      imageBody: new FormControl(''),
    });
    return form
  }

  loadTemplates (isCongress: boolean) {
    this._letterSpeakersService.loadTemplates(isCongress)
      .subscribe((result) => {
        this.templates = result.map(item => {
          let entity = new LetterV2();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.subject = item.payload.doc.data().subject;
          entity.type = item.payload.doc.data().type || '0';
          entity.text = item.payload.doc.data().text;
          entity.event_id = item.payload.doc.data().event_id;
          entity.event_name = item.payload.doc.data().event_name;
          entity.isCongress = item.payload.doc.data().isCongress;
          entity.isTemplate = item.payload.doc.data().isTemplate;
          entity.imageTop = item.payload.doc.data().imageTop;
          entity.imageBottom = item.payload.doc.data().imageBottom;
          entity.imageBody = item.payload.doc.data().imageBody;
          return entity;
        });
        ///
        // console.log("templates: " + JSON.stringify(this.templates))
      })
  }

  selectedTemplateChange (event_id) {
    let selected = this.templates.find((e) => {
      return event_id == e.id
    })

    this.entityForm.controls.name.setValue(selected.name + " - cópia");
    this.entityForm.controls.subject.setValue(selected.subject);
    this.entityForm.controls.type.setValue(selected.type);
    this.entityForm.controls.text.setValue(selected.text);
    this.entityForm.controls.isCongress.setValue(this.isCongress);
    this.entityForm.controls.isTemplate.setValue(false);
    this.entityForm.controls.imageTop.setValue(selected.imageTop);
    this.entityForm.controls.imageBottom.setValue(selected.imageBottom);
    this.entityForm.controls.imageBody.setValue(selected.imageBody);
  }

  updateImages () {

    if (this._letterSpeakersService.objectImageTop) {
      console.log("tem image top")
      this._letterSpeakersService.uploadImageTop(this._letterSpeakersService.objectImageTop, this.letter.id, this.entityForm)
    }

    if (this._letterSpeakersService.objectImageBottom) {
      console.log("tem image bottom")
      this._letterSpeakersService.uploadImageBottom(this._letterSpeakersService.objectImageBottom, this.letter.id, this.entityForm)
    }

    if (this._letterSpeakersService.objectImageBody) {
      console.log("tem image body")
      this._letterSpeakersService.uploadImageBody(this._letterSpeakersService.objectImageBody, this.letter.id, this.entityForm)
    }

    this.snackBar.openSnackBar("Sucesso!", '', 'success');
  }

}


